(function () {
  'use strict';

  var overlay = document.createElement('div');
  overlay.id = 'simple-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Bildansicht');
  overlay.innerHTML =
    '<button type="button" class="simple-lightbox__close" aria-label="Schließen">\u00D7</button>' +
    '<img class="simple-lightbox__img" alt="" />';
  document.body.appendChild(overlay);

  var img = overlay.querySelector('.simple-lightbox__img');
  var closeBtn = overlay.querySelector('.simple-lightbox__close');

  function open(src, alt) {
    img.src = src;
    img.alt = alt || '';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    close();
  });

  img.addEventListener('click', function (e) {
    e.stopPropagation();
    close();
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lightbox-src]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger.dataset.lightboxSrc, trigger.dataset.lightboxAlt || '');
    }
  });
})();
